import { getSelectedCalendarsFromTimePanel } from './getSelectedCalendarsFromTimePanel';
import { flattenObservableMapValues } from 'owa-selected-calendars-utils';

/**
 * NOTE: This only returns information specific to Time Panel config,
 * i.e. it does not cover Calendar module fallback scenario and should
 * only be used when `hasTimePanelSelectedCalendars()` returns true
 */
export function getSelectedCalendarsCount(primarySmtpAddress?: string): number {
    if (primarySmtpAddress) {
        return getSelectedCalendarsCountForUser(primarySmtpAddress);
    } else {
        return getSelectedCalendarsCountForAllMailboxes();
    }
}

function getSelectedCalendarsCountForAllMailboxes(): number {
    return flattenObservableMapValues(getSelectedCalendarsFromTimePanel()).length;
}

function getSelectedCalendarsCountForUser(primarySmtpAddress: string): number {
    const selectedCalendars = getSelectedCalendarsFromTimePanel().get(primarySmtpAddress);
    return selectedCalendars ? selectedCalendars.length : 0;
}
